import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice'
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto'
import EditItem from '../../../../shared/components/IconButtons/EditItem'

const CampoInputSolucao = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { solution } = useSelector(state => state.ocorrenciaState)

    const handleChange = (name, value) => {
        dispatch(handleOcorrenciaChange({[name]: value}))
    }

    useEffect(() => {
        if(!solution) dispatch(handleOcorrenciaChange({solution: ""}))
    }, [solution, dispatch])

    const handleClick = (e) => {
        e.preventDefault()
        onClick("solution")
    }

    return (
        <CampoInputTexto
            id="formInputSolucao"
            titulo="Solução"
            onChange={handleChange}
            name="solution"
            value={solution ? solution : ""}
            disabled={disabled}
            multiline
            maxRows={5}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )

}

export default CampoInputSolucao